import React, { Component } from 'react'
import { connect } from 'react-redux'
import { Field, reduxForm, formValueSelector } from 'redux-form'

import {
  fetchOrganizations,
  getOrganizations,
  getCurrentOrganization,
} from '../../ducks/organizations'
import Button from '../Shared/Button'
import WizardFooter from './WizardFooter'
import WrappedInput from '../Shared/Forms/WrappedInput'
import WrappedColorDropdown from '../Shared/Forms/WrappedColorDropdown'
import WrappedSelect from '../Shared/Forms/WrappedSelect'
import { FORM_NAME } from './shared'
import { defaultBranding } from '../../utils/colors'
import {
  getTemplateBrandingState,
  ensureTemplateBrandingIsLoaded,
} from '../../ducks/apps'
import Loading from '../Shared/Loading'

class WizardFormBrandingPage extends Component {
  componentDidMount() {
    const {
      fetchOrganizations,
      templateId,
      loadedBranding,
      ensureTemplateBrandingIsLoaded,
    } = this.props

    fetchOrganizations()

    if (templateId !== 'blank' && !loadedBranding) {
      ensureTemplateBrandingIsLoaded(templateId)
    }
  }

  getOrganizationOptions = () => {
    const { organizations, currentOrganization } = this.props

    const formattedOrgs = organizations?.map(org => ({
      label: org.name,
      value: org.id,
    }))

    if (!currentOrganization) {
      return formattedOrgs
    }

    const otherOrgs = formattedOrgs.filter(
      org => org.value !== currentOrganization?.id
    )

    return [
      { label: currentOrganization?.name, value: currentOrganization?.id },
      ...otherOrgs,
    ]
  }

  render() {
    const {
      handleSubmit,
      handlePreviousPage,
      onOpenAdvanced,
      loadingBranding,
      name,
      organizations,
      submitting,
    } = this.props

    return (
      <>
        <form
          id="new-app-branding-form"
          className="new-app-form"
          onSubmit={handleSubmit}
        >
          <Field
            name="name"
            component={WrappedInput}
            placeholder="i.e. SpaceX Flight Tracker"
            label="App Name"
            type="text"
          />
          {organizations.length > 1 && (
            <Field
              autoSelect
              name="organizationId"
              component={WrappedSelect}
              options={this.getOrganizationOptions()}
            />
          )}
          {loadingBranding ? (
            <Loading expanded />
          ) : (
            <>
              <Field
                name="primaryColor"
                component={WrappedColorDropdown}
                label="Primary Color"
              />
              <Field
                name="secondaryColor"
                component={WrappedColorDropdown}
                label="Secondary Color"
              />
            </>
          )}
        </form>
        <WizardFooter>
          {handlePreviousPage ? (
            <Button className="previous" onClick={handlePreviousPage}>
              Back
            </Button>
          ) : null}
          <Button className="advanced align-right" onClick={onOpenAdvanced}>
            Advanced Options
          </Button>
          <Button
            className="next"
            type="submit"
            form="new-app-branding-form"
            disabled={!name}
            loading={submitting}
          >
            Create
          </Button>
        </WizardFooter>
      </>
    )
  }
}

function mapStateToProps(state) {
  const selector = formValueSelector(FORM_NAME)
  const templateId = selector(state, 'templateId')
  const primaryColor = selector(state, 'primaryColor')
  const secondaryColor = selector(state, 'secondaryColor')

  const brandingState =
    templateId === 'blank'
      ? { loading: false, loaded: true, branding: defaultBranding }
      : getTemplateBrandingState(state, templateId)

  return {
    templateId,
    loadingBranding: brandingState.loading || !primaryColor || !secondaryColor,
    loadedBranding: brandingState.loaded,
    name: selector(state, 'name'),
    organizations: getOrganizations(state),
    currentOrganization: getCurrentOrganization(state),
  }
}

export default reduxForm({
  form: FORM_NAME,
  destroyOnUnmount: false,
  forceUnregisterOnUnmount: true,
  enableReinitialize: true,
  keepDirtyOnReinitialize: true,
})(
  connect(mapStateToProps, {
    fetchOrganizations,
    ensureTemplateBrandingIsLoaded,
  })(WizardFormBrandingPage)
)
